import { useState, useEffect, useCallback } from 'react';
import { queryCompanies } from 'apis';
import { Company } from 'types';
import { UseCompaniesDataReturn } from './types';
import { COMPANY_LIST_CONSTANTS } from './constants';

const TARGET_COMPANIES = [
  'Amazon',
  'ByteDance', 
  'Microsoft',
  'Meta',
  'Google',
  'Nvidia'
];


export const useCompaniesData = (): UseCompaniesDataReturn => {
  const [companies, setCompanies] = useState<Company[]>([]);
  const [error, setError] = useState<string | null>(null);

  const fetchCompanies = useCallback(async () => {
    try {
      setError(null);
      
      const snapshot = await queryCompanies("company");
      const fetchedCompanies = snapshot.docs
        .map((doc) => ({ id: doc.id, ...doc.data() } as Company))
        .filter((company) => 
          company.referrerCount > 0 && 
          TARGET_COMPANIES.includes(company.company)
        )
        .slice(0, COMPANY_LIST_CONSTANTS.MAX_COMPANIES_DISPLAY);
      
      setCompanies(fetchedCompanies);
    } catch (err) {
      const errorMessage = err instanceof Error 
        ? err.message 
        : 'Failed to fetch companies for home list';
      
      console.error('CompanyList fetch error:', err);
      setError(errorMessage);
    }
  }, []);

  useEffect(() => {
    fetchCompanies();
  }, [fetchCompanies]);

  return {
    companies,
    error,
  };
};
